import { render, staticRenderFns } from "./NavItemSubDropdown.vue?vue&type=template&id=52fd5e1d&"
import script from "./NavItemSubDropdown.vue?vue&type=script&lang=js&"
export * from "./NavItemSubDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports